<script setup lang="ts">

import DetailsHeadingBloc from "@/views/booking/components/DetailsHeadingBloc.vue";
import DetailsImages from "@/views/booking/components/DetailsImages.vue";
import RoomKeyItem from "@/views/booking/components/RoomKeyItem.vue";
import CsaLocation from "@/views/about/CsaLocation.vue";
import DetailsBookingForm from "@/views/booking/components/DetailsBookingForm.vue";
import {useStore} from "vuex";
import Room from "@/models/Room";
const store = useStore();
const roomChoose:Room = store.getters["room/getRoomChoose"];
console.log(roomChoose);
</script>

<template>
  <details-heading-bloc></details-heading-bloc>
  <!-- CONTENT -->
  <div class="uk-padding vert uk-padding-remove-horizontal uk-position-relative mt-5">
    <div class="uk-container uk-container-large">
      <div data-uk-grid>

       <details-images :room-pictures="roomChoose?.room_photos??[]"></details-images>

        <!-- MAIN CONTENT -->
        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-1-1@s">
          <!-- highlight -->
          <p class="impx-text-large">
           Appartement <span class="uk-text-bold"> {{roomChoose.room_name}}</span> - Type:  <span class="uk-text-bold">{{roomChoose?.room_type?.room_type_name??''}}</span><br/>
            <span class="uk-text-bold">
            {{roomChoose.room_total_price}} FCFA/ Nuitée
            </span>
          </p>
          <!-- highlight end -->

          <!-- room description -->
         <room-key-item :room-spec="roomChoose?.room_spec??[]"></room-key-item>
          <h4>Description</h4>

          <p class="uk-margin-medium-bottom">{{roomChoose.room_description??''}}</p>

          <!-- room features list -->
<!--          <div data-uk-grid>-->
<!--            <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">-->
<!--              <h5>Additional Description</h5>-->
<!--              <p>Nihil opus est exemplis hoc facere longius. Quid de Platone aut de Democrito loquar? Voluptatem cum summum bonum diceret, primum in eo ipso parum vidit, deinde hoc quoque alienum; Quo modo autem optimum, si bonum nullum est?</p>-->
<!--            </div>-->
<!--            <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">-->
<!--              <h5>More Facilities</h5>-->
<!--              <ul class="uk-list uk-list-bullet impx-list">-->
<!--                <li>Nihil opus est exemplis hoc facere longius</li>-->
<!--                <li>Voluptatem cum summum bonum diceret</li>-->
<!--                <li>Quo modo autem optimum, si bonum</li>-->
<!--                <li>Beatus autem esse in maximarum</li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->

          <hr class="uk-divider-icon">
        </div>
        <!-- MAIN CONTENT -->

        <!-- SIDEBAR -->
        <details-booking-form></details-booking-form>
<!--        <details-book-now></details-book-now>-->
      </div>
    </div>
  </div>
  <!-- CONTENT END -->
  <csa-location></csa-location>
</template>

<style scoped>

</style>